import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
export const api = axios.create({
    baseURL: '/api',
    withCredentials: true, // send the refresh-token cookie
    timeout: 30_000,
});
// Attach the in-memory access token to every request.
api.interceptors.request.use((config) => {
    const token = useAuthStore.getState().accessToken;
    if (token)
        config.headers.Authorization = `Bearer ${token}`;
    return config;
});
// Refresh-on-401 logic with single-flight deduplication.
let refreshPromise = null;
const refreshAccessToken = async () => {
    if (refreshPromise)
        return refreshPromise;
    refreshPromise = (async () => {
        try {
            const r = await axios.post('/api/auth/refresh', null, { withCredentials: true });
            const token = r.data?.accessToken;
            const user = r.data?.user;
            if (token) {
                useAuthStore.getState().setAccessToken(token);
                if (user)
                    useAuthStore.getState().setUser(user);
                return token;
            }
            return null;
        }
        catch {
            useAuthStore.getState().clear();
            return null;
        }
        finally {
            refreshPromise = null;
        }
    })();
    return refreshPromise;
};
api.interceptors.response.use((r) => r, async (error) => {
    const status = error.response?.status;
    const original = error.config;
    // Only attempt one refresh per request, and never for the refresh endpoint itself.
    const isAuthEndpoint = (original?.url || '').includes('/auth/');
    if (status === 401 && !original?._retried && !isAuthEndpoint) {
        original._retried = true;
        const newToken = await refreshAccessToken();
        if (newToken) {
            original.headers = original.headers || {};
            original.headers.Authorization = `Bearer ${newToken}`;
            return api(original);
        }
    }
    return Promise.reject(error);
});
